import React from 'react';
import './ApplicationStatusHeader.css';

const ApplicationStatusHeader = ({
  applicationStatus,
  referenceNumber,
  submissionDate,
  isReadOnly
}) => {
  if (!applicationStatus) {
    return null;
  }

  const getStatusConfig = () => {
    switch (applicationStatus) {
      case 'submitted':
        return {
          className: 'status-submitted',
          icon: '✓',
          title: null, // Remove title as requested
          message: 'Your application has been successfully submitted and is under review.',
          showReference: true,
          showDate: true
        };
      case 'draft':
        return {
          className: 'status-draft',
          icon: '📝',
          title: 'Draft Application',
          message: 'You can continue editing your application. Your progress has been saved.',
          showReference: false,
          showDate: false
        };
      case 'under_review':
        return {
          className: 'status-review',
          icon: '👀',
          title: 'Under Review',
          message: 'Your application is currently being reviewed by our team.',
          showReference: true,
          showDate: true
        };
      case 'approved':
        return {
          className: 'status-approved',
          icon: '🎉',
          title: 'Application Approved',
          message: 'Congratulations! Your application has been approved.',
          showReference: true,
          showDate: true
        };
      case 'rejected':
        return {
          className: 'status-rejected',
          icon: '❌',
          title: 'Application Rejected',
          message: 'Your application has been rejected. Please contact support for more information.',
          showReference: true,
          showDate: true
        };
      default:
        return null;
    }
  };

  const statusConfig = getStatusConfig();
  if (!statusConfig) return null;

  const formatDate = (dateString) => {
    if (!dateString) return '';
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    } catch (error) {
      return dateString;
    }
  };

  return (
    <div className={`application-status-header ${statusConfig.className}`}>
      <div className="container">
        <div className="status-content">
          <div className="status-main">
            <div className="status-icon">
              {statusConfig.icon}
            </div>
            <div className="status-info">
              {statusConfig.title && (
                <h3 className="status-title">{statusConfig.title}</h3>
              )}
              <p className="status-message">{statusConfig.message}</p>
              {isReadOnly && (
                <p className="readonly-notice">
                  <strong>Note:</strong> This application cannot be modified as it has been submitted.
                </p>
              )}
            </div>
          </div>

          <div className="status-details">
            {statusConfig.showReference && referenceNumber && (
              <div className="status-detail">
                <span className="detail-label">Reference:</span>
                <span className="detail-value">{referenceNumber}</span>
              </div>
            )}
            {statusConfig.showDate && submissionDate && (
              <div className="status-detail">
                <span className="detail-label">Submitted:</span>
                <span className="detail-value">{formatDate(submissionDate)}</span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApplicationStatusHeader;
